<template>
  <div>
    <div class="flex flex-col items-start">
      <slot name="title">
        <p :class="titleClasses">{{ title }}</p>
      </slot>
      <ul :class="linksClasses">
        <li v-for="link in links" :key="link.label">
          <ULink
            class="hover:text-primary duration-300"
            :title="link.titleAttr"
            :to="link.to"
          >
            {{ link.label }}
          </ULink
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router'
import { twMerge } from 'tailwind-merge'

const props = defineProps<{
  links?: {
    label: string | undefined
    titleAttr?: string
    to: RouteLocationRaw
  }[]
  linksClasses?: string
  title?: string
  titleClasses?: string
}>()

const titleClasses = computed(() =>
  twMerge('font-semibold text-sm', props.titleClasses),
)
const linksClasses = computed(() =>
  twMerge('text-xs mt-4 text-gray-700 space-y-1.5', props.linksClasses),
)
</script>

<style></style>
